import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITraveler } from "redux/travelerInformation";
import {
  IAdditionalProducts,
  IAdditionalProduct,
} from "./additionalProducts.interfaces";
import { passengerMapShort } from "@thekilroygroup/shared-ui";

const initialState: IAdditionalProducts = {
  products: [],
};

export const additionalProductsSlice = createSlice({
  name: "additionalProducts",
  initialState,
  reducers: {
    toggleAdditionalProduct: (
      state,
      action: PayloadAction<{
        product: IAdditionalProduct;
        productIndex: number;
        addToAll: boolean;
        travelerIndex?: number;
        travelersTotal: number;
        travelers: ITraveler[];
      }>,
    ) => {
      const {
        product,
        productIndex,
        travelerIndex,
        travelersTotal,
        addToAll,
        travelers,
      } = action.payload;
      const productFromIndex = state.products[productIndex];
      if (addToAll) {
        if (productFromIndex.selectedAll) {
          productFromIndex.selectedAll = false;
          productFromIndex.selectedList = [];
        } else {
          productFromIndex.selectedAll = true;
          if (product.scope === "PASSENGER") {
            const travelersTypes: string[] = product.passengerPriceList.map(
              (ppl) => ppl.passengerGroup,
            );
            const nextSelectedList: number[] = [];
            travelers.forEach((traveler, i) => {
              const pass: string =
                passengerMapShort[
                  traveler.passengerType as keyof typeof passengerMapShort
                ];
              if (travelersTypes.includes(pass)) nextSelectedList.push(i);
            });
            productFromIndex.selectedList = nextSelectedList;
          } else {
            productFromIndex.selectedList = ["BOOKING"];
          }
        }
      } else if (typeof travelerIndex == "number") {
        if (productFromIndex.selectedList.includes(travelerIndex)) {
          productFromIndex.selectedList = productFromIndex.selectedList.filter(
            (index) => index !== travelerIndex,
          );
        } else {
          productFromIndex.selectedList.push(travelerIndex);
        }

        productFromIndex.selectedAll =
          productFromIndex.selectedList.length === travelersTotal;
      }
    },
    setAdditionalProducts: (state, action: PayloadAction<any[]>) => {
      if (state.products.length === 0) {
        state.products = action.payload;
      }
    },
    resetAdditionalProducts: (state) => {
      state.products = [];
    },
  },
});
export const {
  toggleAdditionalProduct,
  setAdditionalProducts,
  resetAdditionalProducts,
} = additionalProductsSlice.actions;
